import { render, staticRenderFns } from "./SmsForm.vue?vue&type=template&id=ce0871b4&scoped=true"
import script from "./SmsForm.vue?vue&type=script&lang=js"
export * from "./SmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0871b4",
  null
  
)

export default component.exports